import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon/fail.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3e44733b")

_pushScopeId("data-v-3e44733b")
const _hoisted_1 = { class: "declare" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 全部 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 待申报 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 申报完成 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 申报失败 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 查询 ")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 待申报 ")
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 申报完成 ")
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 申报失败 ")
const _hoisted_13 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("明细")
const _hoisted_15 = { style: {"float":"right","marginTop":"20px"} }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", null, "申报成功后，计算的结果将不能更改。确定已核对申报订单数和车主数后，进行申报", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withId(() => [
        _createVNode(_component_a_form, {
          labelCol: { style: 'width: 150px' },
          model: _ctx.form,
          rules: _ctx.rules
        }, {
          default: _withId(() => [
            _createVNode(_component_a_row, null, {
              default: _withId(() => [
                _createVNode(_component_a_form_item, {
                  label: "税款所属期:",
                  name: "taxPeriod"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_a_range_picker, {
                      placeholder: ['开始日期', '结束日期'],
                      onChange: _ctx.onChange
                    }, null, 8, ["onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "申报状态:",
                  name: "declareStatus"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_a_select, {
                      "default-value": "0",
                      style: {"width":"320px"},
                      value: _ctx.value,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
                      onChange: _cache[2] || (_cache[2] = (value) => {_ctx.form.state = value})
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_a_select_option, {
                          key: "0",
                          value: "0"
                        }, {
                          default: _withId(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, {
                          key: "1",
                          value: "1"
                        }, {
                          default: _withId(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, {
                          key: "2",
                          value: "2"
                        }, {
                          default: _withId(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, {
                          key: "3",
                          value: "3"
                        }, {
                          default: _withId(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  class: "btn",
                  onClick: _ctx.declareQuery,
                  type: "primary"
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      pagination: false,
      columns: _ctx.columns,
      "data-source": _ctx.data.list,
      rowKey: (record,index)=>{return index},
      bordered: ""
    }, {
      state: _withId(({ text, record }) => [
        (text == 1)
          ? (_openBlock(), _createBlock("span", _hoisted_7, [
              _createVNode(_component_a_badge, { color: "blue" }),
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        (text == 2)
          ? (_openBlock(), _createBlock("span", _hoisted_9, [
              _createVNode(_component_a_badge, { color: "green" }),
              _hoisted_10
            ]))
          : _createCommentVNode("", true),
        (text == 3)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("div", null, [
                _createVNode(_component_a_badge, { color: "#FF4D4F" }),
                _hoisted_12,
                _hoisted_13
              ]),
              _createVNode("a", {
                style: {"margin-left":"17px"},
                onClick: ($event: any) => (_ctx.failReason(record.failReason))
              }, "申报原因", 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      action: _withId(({record}) => [
        (record.state == 1)
          ? (_openBlock(), _createBlock("a", {
              key: 0,
              onClick: ($event: any) => (_ctx.showModal(record))
            }, "申报", 8, ["onClick"]))
          : _createCommentVNode("", true),
        (record.state == 3)
          ? (_openBlock(), _createBlock("a", {
              key: 1,
              onClick: ($event: any) => (_ctx.showModal(record))
            }, "继续执行申报", 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          style: {"margin-left":"9px"},
          to: `/taxDetail?id=${record.skssqq},${record.skssqz},${record.sl},${record.state}`
        }, {
          default: _withId(() => [
            _hoisted_14
          ]),
          _: 2
        }, 1032, ["to"])
      ]),
      _: 1
    }, 8, ["columns", "data-source", "rowKey"]),
    _createVNode("div", _hoisted_15, [
      _createVNode(_component_a_pagination, {
        pageSize: _ctx.data.pageSize,
        "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => (_ctx.data.pageSize = $event)),
        hideOnSinglePage: true,
        current: _ctx.data.pageNum,
        "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => (_ctx.data.pageNum = $event)),
        total: _ctx.data.total,
        onChange: _ctx.onChange1
      }, null, 8, ["pageSize", "current", "total", "onChange"])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      title: "是否现在申报",
      width: "450px",
      centered: "true",
      maskClosable: "false",
      okText: "确定",
      cancelText: "取消",
      onOk: _ctx.handleOk,
      onCancel: _cache[5] || (_cache[5] = () => { _ctx.visible = false })
    }, {
      default: _withId(() => [
        _hoisted_16
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ]))
})